class AlmeaPdpMobileMedia extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('[data-almea-pdp-stage]');
    this.slides = Array.from(this.querySelectorAll('[data-almea-pdp-slide]'));
    this.progressItems = Array.from(this.querySelectorAll('[data-almea-pdp-progress]'));

    if (!this.stage || this.slides.length === 0 || this.progressItems.length === 0) return;

    this.onScroll = this.updateActiveIndex.bind(this);
    this.onResize = this.updateActiveIndex.bind(this);
    this.stage.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.progressItems.forEach((item) => {
      item.addEventListener('click', (event) => {
        const index = Number(item.dataset.index);
        const slide = this.slides[index];

        if (!slide) return;

        event.preventDefault();
        this.stage.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth',
        });
        this.setActiveIndex(index);
      });
    });

    this.updateActiveIndex();
  }

  disconnectedCallback() {
    this.stage?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  updateActiveIndex() {
    const stageWidth = this.stage.clientWidth || 1;
    const index = Math.round(this.stage.scrollLeft / stageWidth);
    this.setActiveIndex(index);
  }

  setActiveIndex(index) {
    const activeIndex = Math.max(0, Math.min(index, this.progressItems.length - 1));

    this.progressItems.forEach((item, itemIndex) => {
      const isActive = itemIndex === activeIndex;

      item.classList.toggle('is-active', isActive);

      if (isActive) {
        item.setAttribute('aria-current', 'true');
      } else {
        item.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('almea-pdp-mobile-media')) {
  customElements.define('almea-pdp-mobile-media', AlmeaPdpMobileMedia);
}
